import { baseAPI } from '~shared/api/base-api';

export interface ExportShowProgramParams {
  recitalId: string;
  format?: 'csv' | 'pdf';
}

export const exportShowProgram = async ({
  recitalId,
  format = 'csv',
}: ExportShowProgramParams): Promise<Blob> => {
  const response = await baseAPI.get(
    `/recitals/${recitalId}/reports/show-program`,
    {
      params: { format },
      responseType: 'blob',
    },
  );
  return response.data;
};

export const downloadShowProgram = async (
  recitalId: string,
  format: 'csv' | 'pdf' = 'csv',
): Promise<void> => {
  const blob = await exportShowProgram({ recitalId, format });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `show-program-${recitalId}.${format}`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
